require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.pathom3.connect.operation.protocols.js");
goog.provide('com.wsscode.pathom3.connect.operation.protocols');
/**
 * @interface
 */

com.wsscode.pathom3.connect.operation.protocols.IOperation = function () {};

var com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$dyn_33207 = function com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$dyn_33207(this$) {
  var x__4428__auto__ = this$ == null ? null : this$;

  var m__4429__auto__ = com.wsscode.pathom3.connect.operation.protocols._operation_config[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(this$) : m__4429__auto__.call(null, this$);
  } else {
    var m__4426__auto__ = com.wsscode.pathom3.connect.operation.protocols._operation_config["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(this$) : m__4426__auto__.call(null, this$);
    } else {
      throw cljs.core.missing_protocol("IOperation.-operation-config", this$);
    }
  }
};

com.wsscode.pathom3.connect.operation.protocols._operation_config = function com$wsscode$pathom3$connect$operation$protocols$_operation_config(this$) {
  if (!(this$ == null) && !(this$.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$arity$1 == null)) {
    return this$.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$arity$1(this$);
  } else {
    return com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_config$dyn_33207(this$);
  }
};

var com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$dyn_33208 = function com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$dyn_33208(this$) {
  var x__4428__auto__ = this$ == null ? null : this$;

  var m__4429__auto__ = com.wsscode.pathom3.connect.operation.protocols._operation_type[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$1(this$) : m__4429__auto__.call(null, this$);
  } else {
    var m__4426__auto__ = com.wsscode.pathom3.connect.operation.protocols._operation_type["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$1 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$1(this$) : m__4426__auto__.call(null, this$);
    } else {
      throw cljs.core.missing_protocol("IOperation.-operation-type", this$);
    }
  }
};

com.wsscode.pathom3.connect.operation.protocols._operation_type = function com$wsscode$pathom3$connect$operation$protocols$_operation_type(this$) {
  if (!(this$ == null) && !(this$.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$arity$1 == null)) {
    return this$.com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$arity$1(this$);
  } else {
    return com$wsscode$pathom3$connect$operation$protocols$IOperation$_operation_type$dyn_33208(this$);
  }
};
/**
 * @interface
 */


com.wsscode.pathom3.connect.operation.protocols.IResolver = function () {};

var com$wsscode$pathom3$connect$operation$protocols$IResolver$_resolve$dyn_33209 = function com$wsscode$pathom3$connect$operation$protocols$IResolver$_resolve$dyn_33209(this$, env, input) {
  var x__4428__auto__ = this$ == null ? null : this$;

  var m__4429__auto__ = com.wsscode.pathom3.connect.operation.protocols._resolve[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(this$, env, input) : m__4429__auto__.call(null, this$, env, input);
  } else {
    var m__4426__auto__ = com.wsscode.pathom3.connect.operation.protocols._resolve["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(this$, env, input) : m__4426__auto__.call(null, this$, env, input);
    } else {
      throw cljs.core.missing_protocol("IResolver.-resolve", this$);
    }
  }
};

com.wsscode.pathom3.connect.operation.protocols._resolve = function com$wsscode$pathom3$connect$operation$protocols$_resolve(this$, env, input) {
  if (!(this$ == null) && !(this$.com$wsscode$pathom3$connect$operation$protocols$IResolver$_resolve$arity$3 == null)) {
    return this$.com$wsscode$pathom3$connect$operation$protocols$IResolver$_resolve$arity$3(this$, env, input);
  } else {
    return com$wsscode$pathom3$connect$operation$protocols$IResolver$_resolve$dyn_33209(this$, env, input);
  }
};
/**
 * @interface
 */


com.wsscode.pathom3.connect.operation.protocols.IMutation = function () {};

var com$wsscode$pathom3$connect$operation$protocols$IMutation$_mutate$dyn_33210 = function com$wsscode$pathom3$connect$operation$protocols$IMutation$_mutate$dyn_33210(this$, env, params) {
  var x__4428__auto__ = this$ == null ? null : this$;

  var m__4429__auto__ = com.wsscode.pathom3.connect.operation.protocols._mutate[goog.typeOf(x__4428__auto__)];

  if (!(m__4429__auto__ == null)) {
    return m__4429__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4429__auto__.cljs$core$IFn$_invoke$arity$3(this$, env, params) : m__4429__auto__.call(null, this$, env, params);
  } else {
    var m__4426__auto__ = com.wsscode.pathom3.connect.operation.protocols._mutate["_"];

    if (!(m__4426__auto__ == null)) {
      return m__4426__auto__.cljs$core$IFn$_invoke$arity$3 ? m__4426__auto__.cljs$core$IFn$_invoke$arity$3(this$, env, params) : m__4426__auto__.call(null, this$, env, params);
    } else {
      throw cljs.core.missing_protocol("IMutation.-mutate", this$);
    }
  }
};

com.wsscode.pathom3.connect.operation.protocols._mutate = function com$wsscode$pathom3$connect$operation$protocols$_mutate(this$, env, params) {
  if (!(this$ == null) && !(this$.com$wsscode$pathom3$connect$operation$protocols$IMutation$_mutate$arity$3 == null)) {
    return this$.com$wsscode$pathom3$connect$operation$protocols$IMutation$_mutate$arity$3(this$, env, params);
  } else {
    return com$wsscode$pathom3$connect$operation$protocols$IMutation$_mutate$dyn_33210(this$, env, params);
  }
};

Object.defineProperty(module.exports, "IOperation", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols.IOperation;
  }
});
Object.defineProperty(module.exports, "_operation_config", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols._operation_config;
  }
});
Object.defineProperty(module.exports, "_operation_type", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols._operation_type;
  }
});
Object.defineProperty(module.exports, "IResolver", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols.IResolver;
  }
});
Object.defineProperty(module.exports, "_resolve", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols._resolve;
  }
});
Object.defineProperty(module.exports, "IMutation", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols.IMutation;
  }
});
Object.defineProperty(module.exports, "_mutate", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.connect.operation.protocols._mutate;
  }
});